// Module
var code = `<div class="candidate-profile-label" ng-if="candidateProfileSubmissionLabelCtrl.submissionLabel"> <div class="candidate-profile-label__title"> {{'SUBMITTED_LABEL' | translate}} </div> <div class="candidate-profile-label__value"> {{candidateProfileSubmissionLabelCtrl.submissionLabel}} </div> </div>`;
// Exports
export default code;